import React from "react";
import { Link, useLocation } from "react-router-dom";
import { PG_BRAND, PG_PHONE, PG_PHONE_TEL } from "../lib/api";
import { Phone } from "lucide-react";

export default function SiteHeader() {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");

  return (
    <header
      className="glass-nav sticky top-0 z-40 border-b border-[#E2E8F0]"
      data-testid="site-header"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-4 flex items-center justify-between">
        <Link to="/" data-testid="logo-link" className="flex items-center gap-2 group">
          <span className="h-8 w-8 rounded-sm bg-[#0A1128] text-[#D4AF37] inline-flex items-center justify-center font-display font-bold">
            P
          </span>
          <span className="font-display text-lg font-semibold tracking-[0.18em] text-[#0A1128]">
            {PG_BRAND}
          </span>
        </Link>

        {!isAdmin && (
          <nav className="hidden md:flex items-center gap-10 text-sm font-medium text-[#475569]">
            <a href="/#services" data-testid="nav-services" className="hover:text-[#0A1128] transition">
              Services
            </a>
            <a href="/#pricing" data-testid="nav-pricing" className="hover:text-[#0A1128] transition">
              Pricing
            </a>
            <a href="/#trust" data-testid="nav-trust" className="hover:text-[#0A1128] transition">
              Why Us
            </a>
          </nav>
        )}

        <div className="flex items-center gap-3">
          <a
            href={`tel:${PG_PHONE_TEL}`}
            data-testid="header-call-btn"
            className="hidden sm:inline-flex items-center gap-2 text-sm font-medium text-[#0A1128] hover:text-[#D4AF37] transition"
          >
            <Phone size={16} strokeWidth={2} />
            {PG_PHONE}
          </a>
          {!isAdmin && (
            <Link
              to="/book"
              data-testid="header-book-btn"
              className="btn-gold inline-flex items-center px-5 py-2.5 rounded-sm text-sm"
            >
              Book Now
            </Link>
          )}
        </div>
      </div>
    </header>
  );
}
